import React, { memo } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

/**
 * Memoized SyntaxHighlighter component to prevent unnecessary re-renders
 * This improves scroll performance when displaying multiple code blocks
 */
const MemoizedSyntaxHighlighter = memo(({ 
  children, 
  language = 'javascript', 
  style = vscDarkPlus,
  customStyle = {},
  wrapLongLines = false,
  showLineNumbers = false,
  ...otherProps 
}) => {
  const defaultCustomStyle = {
    borderRadius: '8px',
    fontSize: '13px',
    margin: 0,
    maxHeight: '400px',
    overflow: 'auto',
    ...customStyle
  };

  return (
    <SyntaxHighlighter
      language={language}
      style={style}
      customStyle={defaultCustomStyle}
      wrapLongLines={wrapLongLines}
      showLineNumbers={showLineNumbers}
      {...otherProps}
    >
      {children}
    </SyntaxHighlighter>
  );
}, (prevProps, nextProps) => {
  // Custom comparison function - only re-render if these props change
  return (
    prevProps.children === nextProps.children &&
    prevProps.language === nextProps.language &&
    JSON.stringify(prevProps.customStyle) === JSON.stringify(nextProps.customStyle)
  );
});

MemoizedSyntaxHighlighter.displayName = 'MemoizedSyntaxHighlighter';

export default MemoizedSyntaxHighlighter;
